import React from 'react';
import { BsGrid } from '@react-icons/all-files/bs/BsGrid';

import { decorateComponent } from '../../documentComponents';
import { getDisallowedAncestors } from '../../utils';
import { Grid } from './Grid';
import { GridInspector } from './Inspector';

export default decorateComponent(Grid, 'block', {
  id: 'grid',
  label: '그리드',
  defaultProps: {},
  allowedChildren: [
    'block',
    'image',
    'text',
    'video',
    'a',
    'coupon',
    'tab',
    'carousel',
    'html-template',
  ],
  disallowedAncestors: getDisallowedAncestors(['grid']),
  renderIcon: () => <BsGrid />,
  renderInspector: GridInspector,
});
